import { FormikHelpers } from 'formik';
import * as Yup from 'yup';
import YupPassword from 'yup-password';

import { getRegexForm } from 'src/utils/utils';

YupPassword(Yup); // extend yup

export interface FormProps<T> {
  /**
   * Handle form submission
   * @returns true if successful, string with error message otherwise
   */
  onSubmit: (values: T, formikHelpers: FormikHelpers<T>) => Promise<true | string>;
  onSubmitTracking?: (success: boolean, reasons?: string[]) => void;
  onBack?: () => void;
}

export const ResetPasswordFormValidation = Yup.object({
  email: Yup.string().email().required(),
});

export const ResendPasswordFormValidation = Yup.object({});

export const ConfirmDetailsFormValidation = Yup.object({
  firstName: Yup.string().required('Please enter a first name').matches(getRegexForm.nameRegex),
  lastName: Yup.string().required('Please enter a last name').matches(getRegexForm.nameRegex),
  marketing: Yup.lazy((value) => (typeof value === 'boolean' ? Yup.boolean() : Yup.string())),
});

export type ConfirmDetailsFormValues = ReturnType<typeof ConfirmDetailsFormValidation.validateSync>;
